/**
 * iKSORIS - WWW
 * SoftCOM Spółka jawna - http://www.softcom.wroc.pl
 * @author SoftCOM Spółka jawna <biuro@softcom.wroc.pl>
 * @copyright Copyright (c) 2010-2014, SoftCOM Spółka jawna
 */

import { Tools } from "../utilities/Tools.js";

class MainSidebar {
    constructor(sidebar) {
        this.sidebar = sidebar;
        this.toggler = sidebar.querySelector('[data-js-main-sidebar="toggler"]');
        this._animationDuration = 0;
        this.timeout = undefined;
        this._isDesktop = false;
        this.init();
    }

    get animationDuration() {
        return this._animationDuration;
    }

    set animationDuration(value) {
        this._animationDuration = parseFloat(value.replace("s", "")) * 1000;
    }

    get isDesktop() {
        return this._isDesktop;
    }

    set isDesktop(value) {
        if (this.isDesktop !== value) {
            this._isDesktop = value;
            this.toggle(undefined, JSON.parse(this.sidebar.getAttribute("aria-expanded")));
        }
    }

    events() {
        const _this = this;

        window.addEventListener("resize", function (event) {
            clearTimeout(_this.timeout);

            _this.timeout = setTimeout(function () {
                _this.isDesktop = Tools.matchMedia("(min-width: 1200px)");
            }, 66);
        });

        document.addEventListener("click", function (event) {
            if (
                event.target.localName === "body" &&
                _this.sidebar.classList.contains("main-sidebar--show") &&
                !_this.isDesktop
            ) {
                _this.toggler.click();
            }
        });

        this.toggler.addEventListener("click", function (event) {
            // Zapisanie czasu trawania aniamacji sidebar'a.
            _this.animationDuration = window
                .getComputedStyle(_this.sidebar, null)
                .getPropertyValue("transition-duration");

            _this.toggle(event, JSON.parse(this.getAttribute("aria-expanded")));
        });
    }

    toggle(event = undefined, expanded) {
        const _this = this;

        if (event) {
            if (this.isDesktop) {
                if (expanded) {
                    this.sidebar.parentElement.classList.add("main-container--full");

                    setTimeout(function () {
                        _this.toggler.setAttribute("aria-expanded", "false");
                    }, this.animationDuration);
                } else {
                    this.sidebar.parentElement.classList.remove("main-container--full");

                    setTimeout(function () {
                        _this.toggler.setAttribute("aria-expanded", "true");
                    }, this.animationDuration);
                }
            } else {
                if (expanded) {
                    // Ukrycie backdrop
                    Tools.bodyBackdrop("hide");

                    //
                    this.sidebar.classList.remove("main-sidebar--show");

                    // Animowane ukrycie .main-sidebar
                    this.sidebar.classList.add("main-sidebar--collapsing-hide");

                    // Po zakończeniu animacji
                    setTimeout(function () {
                        _this.sidebar.classList.remove("main-sidebar--collapsing-hide");
                        _this.toggler.setAttribute("aria-expanded", "false");
                    }, this.animationDuration);
                } else {
                    // Pokazanie backdrop
                    Tools.bodyBackdrop("show");

                    // Animowane pokazanie .main-sidebar
                    this.sidebar.classList.add("main-sidebar--collapsing-show");

                    // Po zakończeniu animacji
                    setTimeout(function () {
                        _this.sidebar.classList.remove("main-sidebar--collapsing-show");
                        _this.toggler.setAttribute("aria-expanded", "true");
                        _this.sidebar.classList.add("main-sidebar--show");
                    }, this.animationDuration);
                }
            }
        } else {
            if (this.isDesktop) {
                // Ukrycie backdrop
                Tools.bodyBackdrop("hide");

                this.sidebar.classList.add("main-sidebar--show");
                this.toggler.setAttribute("aria-expanded", "true");
            } else {
                this.sidebar.parentElement.classList.remove("main-container--full");
                this.sidebar.classList.remove("main-sidebar--show");
                this.toggler.setAttribute("aria-expanded", "false");
            }
        }
    }

    init() {
        this.events();

        // Sprawdzanie rozdzielczości
        this.isDesktop = Tools.matchMedia("(min-width: 1200px)");
    }
}

export { MainSidebar };
